// Token storage abstraction — supports both localStorage (persistent) and sessionStorage.
const KEY = "teslam_token";
const USER_KEY = "teslam_user";
const FLAG = "teslam_persist"; // "1" = use localStorage, anything else = sessionStorage

function backend() {
  return localStorage.getItem(FLAG) === "0" ? sessionStorage : localStorage;
}

export function setPersistent(persist) {
  localStorage.setItem(FLAG, persist ? "1" : "0");
}

export function isPersistent() {
  return localStorage.getItem(FLAG) !== "0";
}

export function setToken(token) {
  backend().setItem(KEY, token);
}

export function getToken() {
  return localStorage.getItem(KEY) || sessionStorage.getItem(KEY) || null;
}

export function clearToken() {
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(USER_KEY);
}

export function setUserSnapshot(user) {
  backend().setItem(USER_KEY, JSON.stringify(user));
}

export function getUserSnapshot() {
  const raw = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
  try { return raw ? JSON.parse(raw) : null; } catch { return null; }
}
